<template>
  <div class="tarja-container">
    <div class="media-column" style="position: relative;">
      <div class="media-background" :style="midiaBgStyle" />
      <div class="media-wrapper">
        <img v-if="midiaType === 'image'" :src="midiaUrl" class="image" style="position: relative;" />
        <video v-else :src="midiaUrl" class="video" autoplay style="position: relative;" />
      </div>
    </div>
    <div class="text-column" :style="textColumnStyle">
      <div class="title-container" :style="titleContainerBgStyle">
        <p class="title-text">{{ headerText }}</p>
      </div>
      <div class="description-container" :style="descriptionContainerBgStyle">
        <p class="description-text" :style="{ lineHeight: lineHeight, fontSize: fontSize }">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-vertical-container.png");
const titleContainerBg = require("../../../assets/tarjas/panela-sportv/midia-texto-titulo.png");
const descriptionContainerBg = require("../../../assets/tarjas/panela-sportv/midia-texto-descricao.png");

export default {
  props: {
    headerText: String,
    text: String,
    lineHeight: String,
    fontSize: String,
    midiaType: String,
    midiaUrl: String,
    midiaSize: Object,
  },
  computed: {
    textColumnStyle() {
      const size = `min-height: ${this.midiaSize.height/3}px`;
      return `${size};`;
    },
    titleContainerBgStyle() {
      const backgroundStyle = `background-image: url(${titleContainerBg}); background-repeat: round`;
      return `${backgroundStyle}`
    },
    descriptionContainerBgStyle() {
      const backgroundStyle = `background-image: url(${descriptionContainerBg}); background-repeat: no-repeat;  background-size: cover; background-size: 100% 100%;`;
      return `${backgroundStyle}`;
    },
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: contain;`;
      return `${backgroundStyle};`;
    }
  },
};
</script>

<style scoped lang="scss">
.image,
.video {
  width: 100%;
  z-index: 1;
  border: 4px solid #bff65c;
  border-radius: 6px;
}

.media-box {
  position: relative;
  width: 194px;
  height: 400px;
  top: 48px;
  left: 32px;
}

.title-text {
  font-family: "Galeana-Condensed-Black", sans-serif;
  color: rgb(255, 255, 255);
  white-space: nowrap;
  font-size: 3rem; 
  line-height: 2.5rem;
}

.description-text {
  font-family: "Galeana-Condensed-Regular", sans-serif;
  font-weight: 600;
  max-width: 530px;
  color: rgb(1, 83, 121);
}

.media-background{
  position: absolute; 
  z-index: 0;
  width: 270px;
  height: 500px;
}

.media-wrapper{
  width: 220px;
  height: 390px;
  display: flex;
  align-items: center;
}

.tarja-container {
  display: flex;
  width: 100%;
  align-items: flex-end;
}

.media-column {
  width: 270px;
  height: 460px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.text-column {
  flex-grow: 1;
  margin-left: -90px;
}

.title-container, .description-container{
  padding-left: 100px;
}

.title-container {
  padding-top: 30px;
  padding-bottom: 60px;
  width: 110%;
}

.description-container {
  width: 105%;
  margin-top: -70px;
  min-height: 100px;
  padding-block: 10px;
  margin-bottom: 10px;
}
</style>
